import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Code2Icon, DatabaseIcon, BotIcon, Share2Icon, TrendingUpIcon } from 'lucide-react';
const services = [{
  icon: <Code2Icon className="w-8 h-8" data-id="element-137" />,
  title: 'Desarrollo Web',
  description: 'Creación de sitios web y plataformas digitales de alto rendimiento, optimizadas para conversión y escalabilidad.'
}, {
  icon: <DatabaseIcon className="w-8 h-8" data-id="element-138" />,
  title: 'Implementación CRM',
  description: 'Gestión inteligente de clientes. Integramos y personalizamos CRMs para centralizar tu operación comercial.'
}, {
  icon: <BotIcon className="w-8 h-8" data-id="element-139" />,
  title: 'Automatización con IA',
  description: 'Optimizamos procesos repetitivos mediante inteligencia artificial, reduciendo costos y aumentando la eficiencia operativa.'
}, {
  icon: <Share2Icon className="w-8 h-8" data-id="element-140" />,
  title: 'Gestión de Redes',
  description: 'Crecimiento estratégico en redes sociales con contenido de valor y gestión de comunidad orientada a marca.'
}, {
  icon: <TrendingUpIcon className="w-8 h-8" data-id="element-141" />,
  title: 'Marketing Digital',
  description: 'Estrategias integrales de adquisición, SEO y SEM diseñadas específicamente para maximizar tu ROI.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ServicesSection() {
  return <section id="servicios" className="py-24 relative z-10" data-id="element-142">
      <div className="container mx-auto px-6 md:px-12" data-id="element-143">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-145">
            Soluciones integrales para la{' '}
            <span className="text-brand-cyan" data-id="element-146">era digital</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-147">
            Combinamos diseño, desarrollo y marketing para crear ecosistemas
            digitales que impulsan el crecimiento real de tu empresa.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-148">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className={`glass-panel p-8 rounded-2xl border border-white/5 hover:border-brand-cyan/30 transition-all duration-300 group ${index === 3 ? 'lg:col-start-1 lg:col-span-1 lg:ml-auto lg:w-full' : ''} ${index === 4 ? 'lg:col-start-2 lg:col-span-1' : ''}`} data-id="element-149">
              <div className="w-14 h-14 rounded-xl bg-brand-dark border border-white/10 flex items-center justify-center text-brand-cyan mb-6 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(0,212,255,0.2)] transition-all duration-300" data-id="element-150">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-brand-cyan transition-colors" data-id="element-151">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-152">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}